import React, { useRef, useEffect } from 'react'
import { css } from '@linaria/core'
import { colors } from '@fs/zion-ui'
import YearMarker from './YearMarker'

const rulerCss = css`
  border-bottom: solid 1px ${colors.gray10};
  display: flex;
  justify-content: space-between;
`

export default function Ruler({ lowYear, highYear, yearStepSize, maxMarkers, setMaxMarkers }) {
  const rulerRef = useRef()

  const yearMarkers = []

  for (let year = lowYear; year <= highYear; year += 10) {
    yearMarkers.push(<YearMarker key={year} year={year} yearStepSize={yearStepSize} />)
  }

  useEffect(() => {
    // Prevents labels from overlapping each other as the screen gets smaller
    setMaxMarkers(rulerRef.current.clientWidth / 40)
  }, [setMaxMarkers])

  return (
    <div ref={rulerRef} className={rulerCss}>
      {maxMarkers > 0 && yearMarkers}
    </div>
  )
}
